// useKeepRateEval — hook fino sobre o keepRateStore (recuperação E5/D).
//
// Devolve { evalData, onLoopEvent }: o SessionWorkspace encaminha TODO evento
// do loop (o store filtra write_file/apply_edit internamente — sem if novo no
// componente, que é dp-loc-ratcheted) e, quando o painel Tasks abre, a medição
// roda contra o conteúdo ATUAL via IPC de arquivo (root da sessão).

import { useCallback, useEffect, useState } from 'react';
import { onLoopToolCall, measureAndAggregate } from '../lib/keepRateStore.js';
import { hasElectronBridge } from '../lib/electronBridge.js';

export function useKeepRateEval(session, panelOpen, panelTab) {
  const active = !!panelOpen && panelTab === 'tasks';
  const [evalData, setEvalData] = useState(null);
  const sessionId = session?.id || '';
  const root = session?.worktree_path || session?.directory || '';

  const onLoopEvent = useCallback(
    (evt) => {
      onLoopToolCall(evt, { sessionId, root }); // E4-T01 — amostra root-scoped
    },
    [sessionId, root],
  );

  useEffect(() => {
    if (!active) return undefined;
    let alive = true;
    const readFile = async (path) => {
      if (!hasElectronBridge() || !root || !path) return null;
      try {
        const bridge = /** @type {any} */ (window).apolo;
        const res = await bridge.file.read({ root, filePath: path });
        return typeof res?.content === 'string' ? res.content : null;
      } catch {
        return null;
      }
    };
    measureAndAggregate({ readFile, root }).then((data) => { // E4-T01 — mede só o root corrente
      if (alive) setEvalData(data);
    });
    return () => {
      alive = false;
    };
  }, [active, root]);

  return { evalData, onLoopEvent };
}
